import { FunctionComponent, ReactNode } from 'react';
import { FormTitle } from '@molecules/FormTitle/FormTitle';
import { NavigationButtons } from '@molecules/NavigationButtons/NavigationButtons';

interface ExtendedButtonProps {
  id?: string;
  label?: string | React.ReactNode;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  loading?: boolean;
}

interface WasteDetailsTemplateProps {
  formTitle: string;
  children: ReactNode;
  buttonNext: ExtendedButtonProps;
  buttonPrevious: ExtendedButtonProps;
}

export const WasteDetailsTemplate: FunctionComponent<
  WasteDetailsTemplateProps
> = ({ buttonNext, buttonPrevious, formTitle, children }) => {
  return (
    <form className="flex flex-col gap-y-4">
      <section data-testid="waste-details-heading" className="">
        <FormTitle text={formTitle} />
      </section>
      {children}
      <NavigationButtons
        buttonNext={{
          ...buttonNext,
          onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
            buttonNext.onClick(event);
            // handleSubmit && handleSubmit();
          },
          label: buttonNext.label,
        }}
        buttonPrevious={buttonPrevious}
      />
    </form>
  );
};
